import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import './PaperTransition.css';

// Keep the file mounted at its natural height: the folder never collapses
// between routes, even when a long record replaces a short one.
const PaperTransition = ({ children, recordKey, className = '', ...props }) => {
  const reduceMotion = useReducedMotion();
  return <motion.div
    {...props}
    key={recordKey}
    className={`paper-transition ${className}`}
    initial={reduceMotion ? false : { y: 6, rotateX: -1.5, opacity: .96 }}
    animate={{ y: 0, rotateX: 0, opacity: 1 }}
    transition={{ duration: reduceMotion ? 0 : .32, ease: [.22, .72, .16, 1] }}
  >
    {children}
  </motion.div>;
};

export default PaperTransition;
